<div id="policy_popup" class="" *ngIf="showPolicy">
    <div appDisableSelection class="close_button_top_left close_work_popup" (click)="closePolicy()"
        (keyup.enter)="closePolicy()" tabindex="0">X</div>
    <div appDisableSelection class="close_button_top_right close_work_popup" (click)="closePolicy()"
        (keyup.enter)="closePolicy()" tabindex="0">X</div>
    <div class="policy_content">
        <h1 i18n="@@encabezadoPoliticaPrivacidad">Política de Privacidad de Apps-Ds Portfolio</h1>

        <h2 i18n="@@tituloIntroduccionPrivacidad">1. Introducción</h2>
        <p i18n="@@textoIntroduccionPrivacidad">Estamos comprometidos a salvaguardar la privacidad de los visitantes de
            nuestro sitio web; esta política establece cómo trataremos su información personal.</p>

        <h2 i18n="@@tituloRecoleccion">2. Recopilación de Información Personal</h2>
        <p i18n="@@textoRecoleccion">(a) Recopilamos su nombre y dirección de correo electrónico cuando envía una
            consulta a través de nuestro formulario web.<br>(b) No utilizamos ninguna herramienta de terceros para
            procesar o almacenar estos datos.</p>

        <h2 i18n="@@tituloUsoInformacion">3. Uso de su Información Personal</h2>
        <p i18n="@@textoUsoInformacion">Los datos personales que se nos envían a través de nuestro sitio web serán
            utilizados exclusivamente para responder a las consultas presentadas por usted.</p>

        <h2 i18n="@@tituloSeguridadDatos">4. Seguridad de sus Datos Personales</h2>
        <p i18n="@@textoSeguridadDatos">Tomamos medidas razonables para evitar la pérdida, mal uso o alteración de su
            información personal. La información se transmite por correo electrónico directamente a nosotros y no se
            almacena en ninguna base de datos.</p>

        <h2 i18n="@@tituloDerechosUsuario">5. Sus Derechos</h2>
        <p i18n="@@textoDerechosUsuario">Puede solicitarnos que le proporcionemos cualquier información personal que
            tengamos sobre usted; la provisión de dicha información estará sujeta a:<br>(a) la confirmación de su
            identidad y<br>(b) no almacenamos su información personal, por lo que cualquier solicitud relacionada con la
            misma será limitada.</p>

        <h2 i18n="@@tituloPoliticaCookies">6. Política de Cookies</h2>
        <p i18n="@@textoPoliticaCookies">Nuestro sitio web no utiliza cookies.</p>

        <h2 i18n="@@tituloActualizacionesPolitica">7. Actualizaciones de esta Política</h2>
        <p i18n="@@textoActualizacionesPolitica">Podemos actualizar esta política de privacidad de vez en cuando
            publicando una nueva versión en nuestro sitio web.</p>

        <h2 i18n="@@tituloContacto">8. Contacto</h2>
        <p i18n="@@textoContacto">Si tiene alguna pregunta sobre esta política de privacidad o nuestro tratamiento de su
            información personal, escríbanos por correo electrónico a <a href="mailto:help@apps-ds.com">help&#64;apps-ds.com</a></p>
    </div>
    <div appDisableSelection class="close_button_bottom_left close_work_popup" (click)="closePolicy()"
        (keyup.enter)="closePolicy()" tabindex="0">X</div>
    <div appDisableSelection class="close_button_bottom_right close_work_popup" (click)="closePolicy()"
        (keyup.enter)="closePolicy()" tabindex="0">X</div>
</div>